(function () {
  const enableAutoplay = true;
  const activeThumbnailStyleId = "shop-active-thumbnail-color";

  if (!document.getElementById(activeThumbnailStyleId)) {
    const activeThumbnailStyle = document.createElement("style");
    activeThumbnailStyle.id = activeThumbnailStyleId;
    activeThumbnailStyle.textContent = ".shop-thumbnail.active{border-color:#4E4D4D!important}";
    document.head.appendChild(activeThumbnailStyle);
  }

  class ProductGallery {
    constructor(container) {
      this.container = container;
      this.mainImages = Array.from(container.querySelectorAll(".shop-main-image"));
      this.zoomWrappers = Array.from(container.querySelectorAll(".shop-image-zoom-wrapper"));
      this.thumbnails = Array.from(container.querySelectorAll(".shop-thumbnail"));
      this.mediaItems = this.mainImages.map((media, index) => this.zoomWrappers[index] || media);
      this.dots = Array.from(container.querySelectorAll(".shop-dot"));
      this.desktopPrevArrow = container.querySelector(".shop-desktop-prev-arrow");
      this.desktopNextArrow = container.querySelector(".shop-desktop-next-arrow");
      this.mobilePrevArrows = Array.from(container.querySelectorAll(".shop-mobile-prev-arrow"));
      this.mobileNextArrows = Array.from(container.querySelectorAll(".shop-mobile-next-arrow"));
      this.indicatorsContainer = container.querySelector(".shop-indicators, #thumbnail-indicators");
      this.currentIndex = 0;
      this.maxIndex = this.mainImages.length - 1;
      this.init();
    }
    init() {
      this.mainImages.forEach((img, i) => {
        img.classList.toggle("active", i === 0);
      });
      this.zoomWrappers.forEach((wrapper, i) => {
        wrapper.classList.toggle("active", i === 0);
      });
      this.thumbnails.forEach((thumb, i) => {
        thumb.classList.toggle("active", i === 0);
      });
      this.dots.forEach((dot, i) => {
        dot.classList.toggle("active", i === 0);
      });
      this.createIndicators();
      this.attachEvents();
      this.setupThumbnailStripDrag();
      this.syncThumbColumnHeight();
      this.applySelectedVariantMediaFilter();
      this.handleVideoAutoplay(this.currentIndex);
      this.touchStartX = 0;
      this.touchEndX = 0;
      this.touchStartY = 0;
      this.touchEndY = 0;
      this.isSwiping = !1;
      this.isPinching = !1;
      this.gestureAxis = null;
      this.swipeThreshold = 40;
      const imageContainer = this.container.querySelector(".shop-main-image-wrapper");
      if (imageContainer && window.matchMedia("(max-width: 767px)").matches) {
        imageContainer.addEventListener(
          "touchstart",
          (e) => {
            if (e.touches.length >= 2) {
              this.isPinching = !0;
              this.isSwiping = !1;
              return;
            }

            this.touchStartX = e.touches[0].clientX;
            this.touchStartY = e.touches[0].clientY;
            this.touchEndX = this.touchStartX;
            this.touchEndY = this.touchStartY;
            this.isPinching = !1;
            this.isSwiping = !0;
            this.gestureAxis = null;
          },
          { passive: !0 },
        );
        imageContainer.addEventListener(
          "touchmove",
          (e) => {
            if (e.touches.length >= 2) {
              this.isPinching = !0;
              this.isSwiping = !1;
              return;
            }
            if (this.isPinching || !this.isSwiping) return;

            this.touchEndX = e.touches[0].clientX;
            this.touchEndY = e.touches[0].clientY;
            const deltaX = this.touchEndX - this.touchStartX;
            const deltaY = this.touchEndY - this.touchStartY;

            if (!this.gestureAxis && (Math.abs(deltaX) > 8 || Math.abs(deltaY) > 8)) {
              this.gestureAxis = Math.abs(deltaX) > Math.abs(deltaY) * 1.15 ? "horizontal" : "vertical";
            }

            if (this.gestureAxis === "horizontal") {
              e.preventDefault();
            }
          },
          { passive: !1 },
        );
        imageContainer.addEventListener(
          "touchend",
          (e) => {
            if (!this.isPinching && this.isSwiping) {
              this.touchEndX = e.changedTouches[0].clientX;
              this.touchEndY = e.changedTouches[0].clientY;
              this.handleSwipeGesture();
            }
            this.resetTouchGesture();
          },
          { passive: !0 },
        );
        imageContainer.addEventListener("touchcancel", () => this.resetTouchGesture(), { passive: !0 });
      }
    }
    attachEvents() {
      this.thumbnails.forEach((thumb, i) => {
        thumb.addEventListener("click", (e) => {
          if (this._thumbStripDragEnded) {
            this._thumbStripDragEnded = false;
            e.preventDefault();
            return;
          }
          this.changeImage(i);
        });
      });
      this.dots.forEach((dot, i) => {
        dot.addEventListener("click", () => this.changeImage(i));
        dot.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            this.changeImage(i);
          }
        });
      });
      if (this.desktopPrevArrow) {
        this.desktopPrevArrow.addEventListener("click", () => {
          const newIndex = this.currentIndex === 0 ? this.maxIndex : this.currentIndex - 1;
          this.changeImage(newIndex);
        });
        this.desktopPrevArrow.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            const newIndex = this.currentIndex === 0 ? this.maxIndex : this.currentIndex - 1;
            this.changeImage(newIndex);
          }
        });
      }
      if (this.desktopNextArrow) {
        this.desktopNextArrow.addEventListener("click", () => {
          const newIndex = this.currentIndex === this.maxIndex ? 0 : this.currentIndex + 1;
          this.changeImage(newIndex);
        });
        this.desktopNextArrow.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            const newIndex = this.currentIndex === this.maxIndex ? 0 : this.currentIndex + 1;
            this.changeImage(newIndex);
          }
        });
      }
      this.mobilePrevArrows.forEach((arrow) => {
        if (arrow) {
          arrow.addEventListener("click", () => {
            const newIndex = this.currentIndex === 0 ? this.maxIndex : this.currentIndex - 1;
            this.changeImage(newIndex);
          });
          arrow.addEventListener("keydown", (e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              const newIndex = this.currentIndex === 0 ? this.maxIndex : this.currentIndex - 1;
              this.changeImage(newIndex);
            }
          });
        }
      });
      this.mobileNextArrows.forEach((arrow) => {
        if (arrow) {
          arrow.addEventListener("click", () => {
            const newIndex = this.currentIndex === this.maxIndex ? 0 : this.currentIndex + 1;
            this.changeImage(newIndex);
          });
          arrow.addEventListener("keydown", (e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              const newIndex = this.currentIndex === this.maxIndex ? 0 : this.currentIndex + 1;
              this.changeImage(newIndex);
            }
          });
        }
      });
      if (this.indicatorsContainer) {
        this.indicatorsContainer.addEventListener("click", (e) => {
          if (e.target.classList.contains("shop-indicator-dot")) {
            const idx = parseInt(e.target.getAttribute("data-index"));
            if (!isNaN(idx)) this.changeImage(idx);
          }
        });
      }

    }
    setupThumbnailStripDrag() {
      if (!window.matchMedia("(min-width: 800px)").matches) return;
      const self = this;
      self._activeThumbDrag = null;

      const duringDrag = (e) => {
        const a = self._activeThumbDrag;
        if (!a || a.pointerId !== e.pointerId) return;
        e.preventDefault();
        if (a.isVertical) {
          const dy = a.startY - e.clientY;
          if (!a.dragStarted && Math.abs(dy) > 5) {
            a.dragStarted = true;
          }
          if (a.dragStarted) {
            a.scrollEl.setAttribute("data-dragging", "1");
            const maxScroll = a.scrollEl.scrollHeight - a.scrollEl.clientHeight;
            const newTop = Math.max(0, Math.min(maxScroll, a.startScroll + dy));
            a.scrollEl.scrollTop = newTop;
            if (!a._loggedScroll) {
              a._loggedScroll = true;
            }
          }
        } else {
          const dx = a.startX - e.clientX;
          if (!a.dragStarted && Math.abs(dx) > 5) {
            a.dragStarted = true;
          }
          if (a.dragStarted) {
            a.scrollEl.setAttribute("data-dragging", "1");
            a.scrollEl.scrollLeft = a.startScroll + dx;
          }
        }
      };

      const stopDragging = (e) => {
        const a = self._activeThumbDrag;
        if (!a || (e && a.pointerId !== e.pointerId)) return;
        if (a.dragStarted) {
          self._thumbStripDragEnded = true;
        } else if (a.downTarget) {
          const i = self.thumbnails.indexOf(a.downTarget);
          if (i >= 0) self.changeImage(i);
        }
        a.scrollEl.removeAttribute("data-dragging");
        self._activeThumbDrag = null;
      };

      document.addEventListener("pointermove", duringDrag, { passive: false });
      document.addEventListener("pointerup", stopDragging, { passive: true });
      document.addEventListener("pointercancel", stopDragging, { passive: true });

      const strips = Array.from(this.container.querySelectorAll(".shop-thumbnails"));
      strips.forEach((thumbStrip) => {
        const wrapper = thumbStrip.closest(".shop-thumbnails-wrapper");
        const isVertical = wrapper && wrapper.classList.contains("left-column-layout");
        const scrollEl = thumbStrip;

        const startDragging = (e) => {
          if (e.button !== 0 && e.type === "mousedown") return;
          const startScroll = isVertical ? scrollEl.scrollTop : scrollEl.scrollLeft;
          self._activeThumbDrag = {
            scrollEl,
            pointerId: e.pointerId,
            startX: e.clientX,
            startY: e.clientY,
            startScroll,
            isVertical,
            downTarget: e.target.closest(".shop-thumbnail"),
            dragStarted: false
          };
          scrollEl.setAttribute("data-dragging", "0");
        };

        if (!scrollEl) return;
        const preventNativeDrag = (e) => e.preventDefault();
        scrollEl.addEventListener("dragstart", preventNativeDrag, { capture: true });
        scrollEl.addEventListener("pointerdown", startDragging, { passive: false });
      });
    }
    syncThumbColumnHeight() {
      if (!window.matchMedia("(min-width: 768px)").matches) return;
      const imageContainer = this.container.querySelector(".shop-image-container");
      const root = this.container.closest(".shop-carousel-container") || this.container;
      if (!imageContainer || !root) return;
      const setHeight = () => {
        const cw = imageContainer.offsetWidth;
        const ch = imageContainer.offsetHeight;
        const activeImg = imageContainer.querySelector(".shop-image-zoom-wrapper.active .shop-main-image, .shop-main-image.active");
        const img = activeImg && activeImg.tagName === "IMG" ? activeImg : imageContainer.querySelector("img.shop-main-image.active");
        let h = ch;
        if (img && img.naturalWidth > 0 && img.naturalHeight > 0) {
          const scale = Math.min(cw / img.naturalWidth, ch / img.naturalHeight);
          h = Math.round(img.naturalHeight * scale);
        }
        if (h > 0) root.style.setProperty("--thumb-column-height", h + "px");
      };
      setHeight();
      this._setThumbColumnHeight = setHeight;
      const ro = new ResizeObserver(() => setHeight());
      ro.observe(imageContainer);
      imageContainer.querySelectorAll("img.shop-main-image").forEach((img) => {
        if (img.complete) setHeight();
        else img.addEventListener("load", setHeight);
      });
    }
    createIndicators() {
      if (!this.indicatorsContainer) return;
      this.indicatorsContainer.innerHTML = "";
      this.mainImages.forEach((_, i) => {
        const dot = document.createElement("div");
        dot.className = "shop-indicator-dot" + (i === 0 ? " active" : "");
        dot.setAttribute("data-index", i);
        this.indicatorsContainer.appendChild(dot);
      });
    }
    changeImage(index) {
      if (index < 0 || index > this.maxIndex || this.isMediaHidden(index)) return;
      this.mainImages.forEach((img, i) => {
        img.classList.toggle("active", i === index);
      });
      this.zoomWrappers.forEach((wrapper, i) => {
        wrapper.classList.toggle("active", i === index);
      });
      this.thumbnails.forEach((thumb, i) => {
        thumb.classList.toggle("active", i === index);
      });
      this.dots.forEach((dot, i) => {
        dot.classList.toggle("active", i === index);
      });
      if (this.indicatorsContainer) {
        Array.from(this.indicatorsContainer.children).forEach((dot, i) => {
          dot.classList.toggle("active", i === index);
        });
      }
      this.currentIndex = index;
      this.scrollToThumbnail(index);
      this.scrollToMainMedia(index);
      this.handleVideoAutoplay(index);
      if (this._setThumbColumnHeight) requestAnimationFrame(() => this._setThumbColumnHeight());
    }
    scrollToThumbnail(index) {
      if (!this.thumbnails[index]) return;
      const thumbnail = this.thumbnails[index];
      const container = thumbnail.parentElement;
      if (!container) return;
      const containerWidth = container.offsetWidth;
      const thumbnailWidth = thumbnail.offsetWidth;
      const thumbnailLeft = thumbnail.offsetLeft;
      const scrollPosition = thumbnailLeft - containerWidth / 2 + thumbnailWidth / 2;
      container.scrollTo({ left: scrollPosition, behavior: "smooth" });
    }
    scrollToMainMedia(index) {
      if (!window.matchMedia("(max-width: 767px)").matches) return;
      const mediaContainer = this.container.querySelector(".shop-image-container");
      const target = this.zoomWrappers[index] || this.mainImages[index];
      if (!mediaContainer || !target || typeof mediaContainer.scrollTo !== "function") return;
      const containerLeft = mediaContainer.getBoundingClientRect().left;
      const targetLeft = target.getBoundingClientRect().left;
      const scrollLeft = mediaContainer.scrollLeft + targetLeft - containerLeft;
      mediaContainer.scrollTo({ left: scrollLeft, behavior: "smooth" });
    }
    handleSwipeGesture() {
      const deltaX = this.touchEndX - this.touchStartX;
      const deltaY = this.touchEndY - this.touchStartY;
      const isHorizontal = Math.abs(deltaX) > Math.abs(deltaY) * 1.15;

      if (isHorizontal && Math.abs(deltaX) > this.swipeThreshold) {
        const direction = deltaX < 0 ? 1 : -1;
        let targetIndex = this.currentIndex + direction;

        while (targetIndex >= 0 && targetIndex <= this.maxIndex && this.isMediaHidden(targetIndex)) {
          targetIndex += direction;
        }

        if (targetIndex >= 0 && targetIndex <= this.maxIndex) this.changeImage(targetIndex);
      }
    }
    resetTouchGesture() {
      this.touchStartX = 0;
      this.touchEndX = 0;
      this.touchStartY = 0;
      this.touchEndY = 0;
      this.isSwiping = !1;
      this.isPinching = !1;
      this.gestureAxis = null;
    }
    handleVideoAutoplay(index) {
      // Pause all videos first
      this.mainImages.forEach((img, i) => {
        const video = img.querySelector("video");
        if (video) {
          video.pause();
          video.currentTime = 0;
          video.controls = false;
          video.muted = true;
          video.defaultMuted = true;
          video.loop = true;
          video.playsInline = true;
          video.setAttribute("muted", "");
          video.setAttribute("loop", "");
          video.setAttribute("playsinline", "");
          video.removeAttribute("controls");
        }
        // Pause external videos (YouTube/Vimeo)
        const iframe = img.querySelector("iframe");
        if (iframe) {
          const src = iframe.src;
          if (src.includes("youtube.com")) {
            iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
          } else if (src.includes("vimeo.com")) {
            iframe.contentWindow.postMessage('{"method":"pause"}', "*");
          }
        }
      });
      
      // Play the active video if autoplay is enabled
      const activeMedia = this.mainImages[index];
      if (!activeMedia) return;
      
      if (enableAutoplay) {
        // Handle local videos
        const videoToPlay = activeMedia.querySelector("video");
        if (videoToPlay) {
          videoToPlay.controls = false;
          videoToPlay.muted = true;
          videoToPlay.defaultMuted = true;
          videoToPlay.loop = true;
          videoToPlay.playsInline = true;
          videoToPlay.preload = "auto";
          videoToPlay.setAttribute("autoplay", "");
          videoToPlay.setAttribute("muted", "");
          videoToPlay.setAttribute("loop", "");
          videoToPlay.setAttribute("playsinline", "");
          videoToPlay.removeAttribute("controls");
          videoToPlay.load();
          videoToPlay.play().catch(() => {});
        }
        
        // Handle external videos (YouTube/Vimeo)
        const iframeToPlay = activeMedia.querySelector("iframe");
        if (iframeToPlay) {
          const src = iframeToPlay.src;
          if (src.includes("youtube.com")) {
            iframeToPlay.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*");
          } else if (src.includes("vimeo.com")) {
            iframeToPlay.contentWindow.postMessage('{"method":"play"}', "*");
          }
        }
      }
    }
    normalizeVariantMediaKey(value) {
      return String(value || "")
        .toLowerCase()
        .replace(/\.[a-z0-9]+(?:\?.*)?$/i, "")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
    }
    getMediaSearchText(index) {
      const main = this.mainImages[index];
      const item = this.mediaItems[index];
      const thumb = this.thumbnails[index];
      const parts = [];
      [main, item, thumb].forEach((el) => {
        if (!el) return;
        parts.push(el.dataset.variantMediaKey, el.dataset.mediaAlt, el.dataset.mediaSrc, el.getAttribute("alt"));
        const img = el.matches && el.matches("img") ? el : (el.querySelector ? el.querySelector("img") : null);
        const source = el.querySelector ? el.querySelector("source") : null;
        if (img) parts.push(img.alt, img.currentSrc, img.src, img.dataset.src, img.dataset.srcset, img.getAttribute("srcset"));
        if (source) parts.push(source.src, source.getAttribute("srcset"));
      });
      return this.normalizeVariantMediaKey(parts.filter(Boolean).join(" "));
    }
    getSelectedVariantColor() {
      const selectors = Array.from(document.querySelectorAll("variant-selects"));
      for (const selector of selectors) {
        const fieldsets = Array.from(selector.querySelectorAll("fieldset"));
        for (const fieldset of fieldsets) {
          const fieldsetLabel = fieldset.querySelector("legend, .form__label");
          const label = this.normalizeVariantMediaKey((fieldsetLabel && fieldsetLabel.textContent) || "");
          if (!/(^|-)colou?r($|-)/.test(label)) continue;
          const checked = fieldset.querySelector("input[type='radio']:checked");
          if (checked) return this.normalizeVariantMediaKey(checked.value || checked.getAttribute("value"));
        }
        const selects = Array.from(selector.querySelectorAll("select"));
        for (const select of selects) {
          const selectLabel = select.closest("label");
          const label = this.normalizeVariantMediaKey((selectLabel && selectLabel.textContent) || select.getAttribute("name") || select.id || "");
          if (!/(^|-)colou?r($|-)/.test(label)) continue;
          return this.normalizeVariantMediaKey(select.value);
        }
      }
      const checkedInputs = Array.from(document.querySelectorAll("input[type='radio']:checked"));
      const checkedColor = checkedInputs.find((input) => {
        const wrapper = input.closest("fieldset, .product-form__input, variant-selects");
        return /colou?r/i.test([input.name, input.id, input.getAttribute("aria-label"), wrapper && wrapper.textContent].filter(Boolean).join(" "));
      });
      if (checkedColor) return this.normalizeVariantMediaKey(checkedColor.value || checkedColor.getAttribute("value"));
      const colorSelect = Array.from(document.querySelectorAll("select")).find((select) => {
        const wrapper = select.closest("label, .product-form__input, variant-selects");
        return /colou?r/i.test([select.name, select.id, select.getAttribute("aria-label"), wrapper && wrapper.textContent].filter(Boolean).join(" "));
      });
      if (colorSelect) return this.normalizeVariantMediaKey(colorSelect.value);
      return "";
    }
    getVariantMediaColor(index) {
      const text = this.getMediaSearchText(index);
      const match = text.match(/(?:^|-)(black|pink|aqua|blue|grey|gray|red)-[0-9]+(?:-|$)/);
      if (!match) return "";
      return match[1] === "gray" ? "grey" : match[1];
    }
    isMediaHidden(index) {
      const item = this.mediaItems[index] || this.mainImages[index];
      return !!(item && item.classList && item.classList.contains("shop-variant-media-hidden"));
    }
    getFirstVisibleIndex() {
      const index = this.mediaItems.findIndex((_, i) => !this.isMediaHidden(i));
      return index >= 0 ? index : 0;
    }
    applySelectedVariantMediaFilter() {
      let selectedColor = this.getSelectedVariantColor();
      selectedColor = {
        "black": "black",
        "pastel-pink": "pink",
        "pink": "pink",
        "aqua": "aqua",
        "pale-blue": "blue",
        "blue": "blue",
        "grey": "grey",
        "gray": "grey",
        "deep-red": "red",
        "red": "red"
      }[selectedColor] || selectedColor;
      const knownColors = ["black", "pink", "aqua", "blue", "grey", "red"];
      if (!knownColors.includes(selectedColor)) return;

      let visibleCount = 0;
      this.mediaItems.forEach((item, index) => {
        const mediaColor = this.getVariantMediaColor(index);
        const shouldHide = mediaColor !== selectedColor;
        if (item && item.classList) item.classList.toggle("shop-variant-media-hidden", shouldHide);
        if (this.mainImages[index] && this.mainImages[index].classList) this.mainImages[index].classList.toggle("shop-variant-media-hidden", shouldHide);
        if (this.thumbnails[index] && this.thumbnails[index].classList) this.thumbnails[index].classList.toggle("shop-variant-media-hidden", shouldHide);
        if (!shouldHide) {
          if (item && item.classList) item.classList.remove("visually-hidden");
          if (this.mainImages[index] && this.mainImages[index].classList) this.mainImages[index].classList.remove("visually-hidden");
          if (this.thumbnails[index] && this.thumbnails[index].classList) this.thumbnails[index].classList.remove("visually-hidden");
          visibleCount += 1;
        }
      });

      if (visibleCount === 0) return;

      const activeVisibleIndex = this.mediaItems.findIndex((item, index) => {
        const media = item || this.mainImages[index];
        return media && media.classList && media.classList.contains("active") && !this.isMediaHidden(index);
      });
      const nextIndex = activeVisibleIndex >= 0 ? activeVisibleIndex : this.getFirstVisibleIndex();
      this.changeImage(nextIndex);
    }
    updateWithVariant(variant) {
      let matchIndex = -1;
      if (variant && (variant.mediaId || variant.variantId || variant.imageUrl)) {
        this.mainImages.forEach((img, i) => {
          if (
            (variant.mediaId && img.dataset.mediaId == variant.mediaId) ||
            (variant.variantId && img.dataset.variantId == variant.variantId) ||
            (variant.imageUrl &&
              (img.src.includes(variant.imageUrl) || (img.dataset.src && img.dataset.src.includes(variant.imageUrl))))
          ) {
            matchIndex = i;
          }
        });
      }
      this.applySelectedVariantMediaFilter();
      if (matchIndex >= 0 && !this.isMediaHidden(matchIndex)) {
        this.changeImage(matchIndex);
      } else {
        this.changeImage(this.getFirstVisibleIndex());
      }
    }
  }
  const galleryRegistry = [];
  function initAll() {
    document.querySelectorAll(".product-gallery").forEach((container) => {
      if (!container.__galleryInstance) {
        const gallery = new ProductGallery(container);
        container.__galleryInstance = gallery;
        galleryRegistry.push(gallery);
      }
    });
  }
  document.addEventListener("variantImageSelected", function (e) {
    if (e.detail && (e.detail.variantId || e.detail.mediaId || e.detail.imageUrl)) {
      galleryRegistry.forEach((gallery) => gallery.updateWithVariant(e.detail));
    }
  });
  document.addEventListener("variant:imageChanged", function (e) {
    if (e.detail && (e.detail.variantId || e.detail.mediaId || e.detail.imageUrl)) {
      galleryRegistry.forEach((gallery) => gallery.updateWithVariant(e.detail));
    }
  });
  function refreshVariantMediaFilters() {
    window.setTimeout(() => {
      galleryRegistry.forEach((gallery) => gallery.applySelectedVariantMediaFilter());
    }, 0);
  }
  document.addEventListener("change", function (event) {
    const target = event.target;
    if (!target || !target.closest) return;
    if (target.closest("variant-selects") || /colou?r/i.test(target.name || target.id || "")) {
      refreshVariantMediaFilters();
    }
  });
  document.addEventListener("click", function (event) {
    const target = event.target;
    if (!target || !target.closest) return;
    const optionInput = target.closest("input[type='radio'], label, variant-selects");
    if (target.closest("variant-selects") || (optionInput && /colou?r/i.test(optionInput.getAttribute("name") || optionInput.getAttribute("for") || optionInput.textContent || ""))) {
      refreshVariantMediaFilters();
    }
  });
  window.addEventListener("variantChanged", refreshVariantMediaFilters);
  document.addEventListener("variantSelected", refreshVariantMediaFilters);
  function exposeGalleryApi() {
    try {
      window.ProductGallery = { initAll, getAll: () => galleryRegistry };
    } catch (error) {
      // Some Shopify preview contexts make window non-extensible. The gallery still needs to initialize.
    }
  }

  exposeGalleryApi();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);
})();

(function () {
  const colorMap = {
    "black": "black", "pastel-pink": "pink", "pink": "pink", "aqua": "aqua",
    "pale-blue": "blue", "blue": "blue", "grey": "grey", "gray": "grey",
    "deep-red": "red", "red": "red"
  };
  const knownColors = ["black", "pink", "aqua", "blue", "grey", "red"];

  function normalize(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/\.[a-z0-9]+(?:\?.*)?$/i, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function isColorControl(control) {
    const context = [control.name, control.id, control.getAttribute && control.getAttribute("aria-label")].filter(Boolean).join(" ");
    const wrapper = control.closest && control.closest("fieldset, .product-form__input, variant-selects");
    return /colou?r/i.test(context + " " + (wrapper ? wrapper.textContent : ""));
  }

  function selectedColorPrefix() {
    const checked = Array.from(document.querySelectorAll('input[type="radio"]:checked')).find(isColorControl);
    if (checked) return colorMap[normalize(checked.value)] || normalize(checked.value);
    const select = Array.from(document.querySelectorAll("select")).find(isColorControl);
    if (select) return colorMap[normalize(select.value)] || normalize(select.value);
    return "";
  }

  function mediaColor(element) {
    if (!element) return "";
    const img = element.tagName === "IMG" ? element : element.querySelector("img");
    const text = normalize([
      element.dataset.variantMediaKey,
      element.dataset.mediaSrc,
      element.dataset.mediaAlt,
      img && img.getAttribute("src"),
      img && img.getAttribute("srcset"),
      img && img.getAttribute("alt")
    ].filter(Boolean).join(" "));
    const match = text.match(/(?:^|-)(black|pink|aqua|blue|grey|gray|red)-[0-9]+(?:-|$)/);
    if (!match) return "";
    return match[1] === "gray" ? "grey" : match[1];
  }

  function preloadImageUrl(src) {
    if (!src) return;
    const preload = new Image();
    preload.decoding = 'async';
    preload.loading = 'eager';
    preload.src = src;
  }

  function preloadSrcset(srcset) {
    String(srcset || '').split(',').forEach((candidate) => {
      const src = candidate.trim().split(/\s+/)[0];
      preloadImageUrl(src);
    });
  }

  function warmImageElement(img) {
    if (!img) return;
    img.loading = 'eager';
    img.decoding = 'async';
    img.setAttribute('fetchpriority', 'high');
    if (img.dataset && img.dataset.src && !img.src) img.src = img.dataset.src;
    if (img.dataset && img.dataset.srcset && !img.srcset) img.srcset = img.dataset.srcset;
    preloadImageUrl(img.currentSrc || img.src || (img.dataset && img.dataset.src));
    preloadSrcset(img.srcset || (img.dataset && img.dataset.srcset));
  }

  function preloadVariantMediaGroup(selected) {
    if (!knownColors.includes(selected)) return;
    document.querySelectorAll('.product-gallery').forEach((gallery) => {
      const media = Array.from(gallery.querySelectorAll('.shop-image-container > .shop-image-zoom-wrapper, .shop-image-container > .shop-main-image'));
      const thumbs = Array.from(gallery.querySelectorAll('.shop-thumbnail'));
      media.forEach((item, index) => {
        const thumb = thumbs[index];
        const color = mediaColor(item) || mediaColor(thumb);
        if (color !== selected) return;
        [item, thumb].forEach((element) => {
          if (!element) return;
          const img = element.matches && element.matches('img') ? element : element.querySelector && element.querySelector('img');
          warmImageElement(img);
          preloadImageUrl(element.dataset && element.dataset.mediaSrc);
          preloadSrcset(element.dataset && element.dataset.srcset);
        });
      });
    });
  }

  function setActiveVisible(gallery, media, thumbs) {
    const firstVisible = media.findIndex((item) => !item.classList.contains("shop-variant-media-hidden"));
    if (firstVisible < 0) return;
    const activeVisible = media.findIndex((item) => item.classList.contains("active") && !item.classList.contains("shop-variant-media-hidden"));
    const targetIndex = activeVisible >= 0 ? activeVisible : firstVisible;
    media.forEach((item, index) => {
      const active = index === targetIndex;
      item.classList.toggle("active", active);
      const image = item.querySelector("img.shop-main-image");
      if (image) image.classList.toggle("active", active);
    });
    thumbs.forEach((thumb, index) => thumb.classList.toggle("active", index === targetIndex));

    if (gallery.__galleryInstance) gallery.__galleryInstance.currentIndex = targetIndex;

    if (activeVisible < 0) {
      const scroller = gallery.querySelector(".shop-image-container");
      const target = media[targetIndex];
      if (scroller && target && typeof scroller.scrollTo === "function") scroller.scrollTo({ left: target.offsetLeft, behavior: "auto" });
    }
  }

  function clearGlobalVariantMediaFilter() {
    document.querySelectorAll(".product-gallery").forEach((gallery) => {
      gallery.querySelectorAll(".shop-variant-media-hidden").forEach((item) => item.classList.remove("shop-variant-media-hidden"));
    });
  }

  function applyGlobalVariantMediaFilter() {
    const selected = selectedColorPrefix();
    if (!knownColors.includes(selected)) {
      clearGlobalVariantMediaFilter();
      return;
    }
    document.querySelectorAll(".product-gallery").forEach((gallery) => {
      const media = Array.from(gallery.querySelectorAll(".shop-image-container > .shop-image-zoom-wrapper, .shop-image-container > .shop-main-image"));
      const thumbs = Array.from(gallery.querySelectorAll(".shop-thumbnail"));
      let visibleCount = 0;
      media.forEach((item, index) => {
        const color = mediaColor(item) || mediaColor(thumbs[index]);
        const shouldHide = color !== selected;
        item.classList.toggle("shop-variant-media-hidden", shouldHide);
        if (thumbs[index]) thumbs[index].classList.toggle("shop-variant-media-hidden", shouldHide);
        if (!shouldHide) {
          item.classList.remove("visually-hidden");
          if (thumbs[index]) thumbs[index].classList.remove("visually-hidden");
          visibleCount += 1;
        }
      });
      if (visibleCount > 0) setActiveVisible(gallery, media, thumbs);
    });
  }

  function scheduleGlobalVariantMediaFilter() {
    const selected = selectedColorPrefix();
    preloadVariantMediaGroup(selected);
    window.setTimeout(applyGlobalVariantMediaFilter, 0);
    window.setTimeout(() => preloadVariantMediaGroup(selectedColorPrefix()), 25);
    window.setTimeout(applyGlobalVariantMediaFilter, 75);
    window.setTimeout(() => preloadVariantMediaGroup(selectedColorPrefix()), 150);
    window.setTimeout(applyGlobalVariantMediaFilter, 500);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", scheduleGlobalVariantMediaFilter);
  else scheduleGlobalVariantMediaFilter();

  document.addEventListener("change", (event) => {
    const target = event.target;
    if (target && target.closest && (target.closest("variant-selects") || isColorControl(target))) scheduleGlobalVariantMediaFilter();
  });
  document.addEventListener("click", (event) => {
    const target = event.target;
    if (target && target.closest) {
      const label = target.closest("label");
      const control = label && label.htmlFor ? document.getElementById(label.htmlFor) : null;
      if (target.closest("variant-selects") || (control && isColorControl(control))) scheduleGlobalVariantMediaFilter();
    }
  });
  document.addEventListener("shopify:section:load", scheduleGlobalVariantMediaFilter);
  window.applyProductVariantMediaFilter = applyGlobalVariantMediaFilter;
})();

(function () {
  function visibleItems(gallery) {
    return {
      media: Array.from(gallery.querySelectorAll('.shop-image-container > .shop-image-zoom-wrapper, .shop-image-container > .shop-main-image')).filter((item) => getComputedStyle(item).display !== 'none'),
      thumbs: Array.from(gallery.querySelectorAll('.shop-thumbnail')).filter((item) => getComputedStyle(item).display !== 'none')
    };
  }

  function activateVisibleThumbnail(thumbnail) {
    const gallery = thumbnail.closest('.product-gallery');
    if (!gallery) return;
    const items = visibleItems(gallery);
    const visibleIndex = items.thumbs.indexOf(thumbnail);
    if (visibleIndex < 0 || !items.media[visibleIndex]) return;

    items.media.forEach((media, index) => {
      const active = index === visibleIndex;
      media.classList.toggle('active', active);
      const image = media.querySelector('img.shop-main-image');
      if (image) image.classList.toggle('active', active);
    });
    items.thumbs.forEach((thumb, index) => thumb.classList.toggle('active', index === visibleIndex));

    const scroller = gallery.querySelector('.shop-image-container');
    const target = items.media[visibleIndex];
    if (scroller && target && typeof scroller.scrollTo === 'function') {
      const containerLeft = scroller.getBoundingClientRect().left;
      const targetLeft = target.getBoundingClientRect().left;
      scroller.scrollTo({ left: scroller.scrollLeft + targetLeft - containerLeft, behavior: 'smooth' });
    }
  }

  function handleThumbnailActivation(event) {
    const thumbnail = event.target && event.target.closest ? event.target.closest('.shop-thumbnail') : null;
    if (!thumbnail || getComputedStyle(thumbnail).display === 'none') return;
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    activateVisibleThumbnail(thumbnail);
  }

  document.addEventListener('click', handleThumbnailActivation, true);
  document.addEventListener('touchend', handleThumbnailActivation, true);
})();
